import React from 'react'
import { useLocalization } from '@/hooks/localization'

export const Name = ({ data, isHtml = false }) => {
  const { localizeValue } = useLocalization()
  const { name, latinName } = data || {}
  const ret = localizeValue(name, latinName)
  if (isHtml) {
    return <span dangerouslySetInnerHTML={{ __html: ret }} />
  }
  return ret || null
}

export default Name



// WEBPACK FOOTER //
// ./src/components/Name.js